/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Law_P2_BeforeInputs */

const es_l7_law_p2_before = /** @type {(inputs: L7_Law_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nueva normativa permite el alquiler de Lista séptima hasta tres meses al año, siempre que una `)
};

const gl_l7_law_p2_before = /** @type {(inputs: L7_Law_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A nova normativa permite o alugueiro de Lista sétima ata tres meses ao ano, sempre que unha `)
};

const en_l7_law_p2_before = /** @type {(inputs: L7_Law_P2_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The new rules allow List 7 rental for up to three months a year, provided an `)
};

/**
* | output |
* | --- |
* | "The new rules allow List 7 rental for up to three months a year, provided an" |
*
* @param {L7_Law_P2_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_law_p2_before = /** @type {((inputs?: L7_Law_P2_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Law_P2_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_law_p2_before(inputs)
	if (locale === "en") return en_l7_law_p2_before(inputs)
	return es_l7_law_p2_before(inputs)
});